import BigNumber from 'bignumber.js';
import { getToken } from 'utilities';

export const BRN_DECIMALS = getToken('brn').decimals;
export const MINTED_BRN = '23700000';
export const MINTED_BRN_WEI = new BigNumber(MINTED_BRN).times(new BigNumber(10).pow(BRN_DECIMALS));
